import "./CourseInsights.css";

function CourseInsights({
  popularCourses = [],
  popularSearches = [],
  onCourseSelect,
}) {
  return (
    <section className="course-insights-section" id="popular">
      <p className="section-eyebrow">Course Insights</p>
      <h2>Popular Courses and Search Trends</h2>

      <div className="insights-grid">
        <div className="insight-card">
          <h3>Top 3 Most Viewed Courses</h3>
          {popularCourses.length === 0 ? (
            <p className="insight-empty">
              Course popularity will appear here after visitors start clicking
              course cards.
            </p>
          ) : (
            <ul className="insight-list">
              {popularCourses.slice(0, 3).map((course, index) => (
                <li key={course._id} className="insight-item">
                  <button
                    className="insight-link"
                    onClick={() => onCourseSelect && onCourseSelect(course)}
                  >
                    <div className="insight-left">
                      <span className="rank-number">{index + 1}</span>
                      <span className="course-title">
                        {course.post_title || course.title}
                      </span>
                    </div>
                    <span className="metric">
                      {course.click_count || course.viewCount || 0} clicks
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="insight-card">
          <h3>Top 3 Most Searched Courses</h3>
          {popularSearches.length === 0 ? (
            <p className="insight-empty">
              Search trends will appear here after visitors search for courses.
            </p>
          ) : (
            <ul className="insight-list">
              {popularSearches.slice(0, 3).map((course, index) => (
                <li key={course._id} className="insight-item">
                  <button
                    className="insight-link"
                    onClick={() => onCourseSelect && onCourseSelect(course)}
                  >
                    <div className="insight-left">
                      <span className="rank-number">{index + 1}</span>
                      <span className="course-title">
                        {course.post_title || course.title}
                      </span>
                    </div>
                    <span className="metric">
                      {course.search_count || course.searchCount || 0} searches
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
}

export default CourseInsights;
